export const emptyPhoto = {
  url: {
    masterImage: '',
  },
  caption: '',
  titleAttribution: '',
}
